import { Injectable, Input, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService'; 
import { APIServiceConnector } from './APIServiceConnector';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest, ComplainRegister, ComplainSearch, ComplainGSRAnswers, Glitch_UpdateRequest, Glitch_SearchRequest, Glitch_ActionRequest } from '../Models/RequestModels';
import { AppSettings } from '../Library/AppSettings';
import { SimpleResponse, ListResponse } from '../Models/ResponseModels';
import { MasterDataService } from './MasterDataService';
import * as moment from 'moment';
const momentDuration = require("moment-duration-format");
import { ComplainSearch_GroupBy, JobOperationActions, GlitchSearch_GroupBy, GlitchOperationActions } from '../Models/EnumModels';
import * as alasql from 'alasql';
import { GenericMaster } from '../Models/GlobalEntities';
  
//declare module 'moment' { 
//    interface Duration {
//        format(template: string, precision?: string, settings?: DurationFormatSettings): string;
//    }

//    //interface DurationFormatSettings {
//    //    template: string; 
//    //    precision: number;
//    //    trim: boolean;
//    //    forceLength: boolean;
//    //}
//}


@Injectable()
export class GlitchService extends BaseService {
    public _SelectedGlitch: any = null;

    public RequireFullRefresh: EventEmitter<any> = new EventEmitter<any>();
    public InitiateEdit: EventEmitter<Glitch_UpdateRequest> = new EventEmitter<Glitch_UpdateRequest>();
    public InitiateCopy: EventEmitter<Glitch_UpdateRequest> = new EventEmitter<Glitch_UpdateRequest>();

    Cache_UpdatedComplains: Array<any> = [];

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService) {
        super();
        this.BaseURL = AppSettings.URL_GlitchService;

        let m: any;
        m = momentDuration;
        m(moment);
    }

    public set SelectedGlitch(value: any) {
        this._SelectedGlitch = value;
    }

    public get SelectedGlitch() :any {
        return this._SelectedGlitch;
    }

    Glitch_Register(req: Glitch_UpdateRequest): Promise<SimpleResponse> {
        if (req == null)
            return null;

        return this.apiService.postAPI(this.BaseURL, "Glitch/Glitch_Register", req).then(data => {
            if (data != null && data.Result != null && data.HasError == false)
                this.Glitch_SetText(data.Result);

            return data;
        });
    }

    Glitch_RegisterMultiple(req: Glitch_UpdateRequest[]): Promise<ListResponse> {
        if (!req) {
            return null
        }
        
        return this.apiService.postAPI(this.BaseURL, "Glitch/Glitch_RegisterMultipleV2", req)
            .then(data => {
                if (data != null && data.Result != null) {
                    this.Glitch_SetText_ListWithErrors(data.Result)
                }
                return data;
            })
    }

    private Glitch_SetText_List(req: Array<any>): void {
        if (req == null || req.length == 0)
            return;

        for (let i = 0; i < req.length; i++) {
            let row = req[i];
            this.Glitch_SetText(row);
        }
    }

    private Glitch_SetText_ListWithErrors(req: Array<any>): void {
        if (req == null || req.length == 0)
            return;

        for (let i = 0; i < req.length; i++) {
            let row = req[i];
            this.Glitch_SetText_WithErrors(row);
        }
    }

    Glitch_Search_Groups_Multi(req: ListResponse, Request: Glitch_SearchRequest): void {
        if (req == null)
            return;

        if (req.Result == null)
            return;

        let lst = new Array<any>();

        for (let i = 0; i < Request.Properties.length; i++) {
            let propID = Request.Properties[i];

            let objProp = this.masterService.Cache_PropertyMainMasters.getValue(propID);

            if (objProp != null) {
                let res: Array<any>;

                switch (Request.GroupBy) {
                    case GlitchSearch_GroupBy.GlitchDescriptionMaster:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.GlitchDescriptionMaster, lst]));
                        break;
                    case GlitchSearch_GroupBy.GlitchCategories:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.GlitchCategories, lst]));
                        break;
                    case GlitchSearch_GroupBy.Dept:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.Dept, lst]));
                        break;
                    case GlitchSearch_GroupBy.Location:
                        lst = lst.concat(objProp.Location);
                        break;
                }
            }

        }

        for (let i = 0; i < req.Result.length; i++) {
            let row = req.Result[i];

            let str: string = "";

            switch (Request.GroupBy) {
                case GlitchSearch_GroupBy.Dept:
                    str = alasql("Select Value Name from ? where Id = ?", [lst, row.Id]);
                    break;
                case GlitchSearch_GroupBy.GlitchCategories:
                case GlitchSearch_GroupBy.GlitchDescriptionMaster:
                case GlitchSearch_GroupBy.Location:
                    str = alasql("Select Value Description from ? where Id = ?", [lst, row.Id]);
                    break;
                case GlitchSearch_GroupBy.Property:
                    let prop = this.masterService.GetProperty(row.Id);
                    if (prop != null)
                        str = prop.PropertyName;
                    break;
            }

            row.GroupName = str;
        }
    }

    Glitch_SetText_WithErrors(row: any) {
        const glitch = row && row.Result
        this.Glitch_SetText(glitch);
        if (row.HasError && this.FindError(row.Errors, 'ERR_GLITCH_DUPLICATE')) {
            glitch.IsDuplicate = true;
        } else if (row.HasError) {
            glitch.IsError = true;
        }

        if (row) {
            row.Result = glitch;
        }
        return row
    }


    Glitch_SetText(row: any): void {
        if (row == null)
            return;

        let propId = row.PropertyId;
        let propInfo = this.masterService.GetProperty(propId);

        row.PropertyCode = "";
        row.PropertyName = "";

        if (propInfo != null) {
            row.PropertyCode = propInfo.PropertyCode;
            row.PropertyName = propInfo.PropertyName;
        }

        if (row.ClosedDate) {
            row.ClosedDate = moment(row.ClosedDate).toDate();
        }

        if (row.LogTime) {
            row.LogTime = moment(row.LogTime).toDate();
        }

        if (row.GlitchIncedentDt) {
            row.GlitchIncedentDt = moment(row.GlitchIncedentDt).toDate();
        }

        row.ElaspedTimeText = "";

        if (row.IsOpen == true) {
            let dtEnd = moment();
            let dtNow = moment(row.LogTime);
            let dura = moment.duration(dtEnd.diff(dtNow));
            //console.info(row.JobEndTime);

            row.ElaspedTimeText = dura.format('dd:hh:mm:ss', { trim: 'all' });
        }


        row.CategoryDescription = this.masterService.MasterData_GetMutli(propId, row.CategoryId, enumModels.EntityCodes.GlitchCategories, "");
        row.DepartmentName = this.masterService.MasterData_GetMutli(propId, row.DepartmentId, enumModels.EntityCodes.Dept, "");
        row.GlitchRegistrationTypeName = this.masterService.MasterData_GetMutli(propId, row.GlitchRegistrationType, enumModels.EntityCodes.GlitchRegistrationTypes, "");
        row.GlitchStaffName = this.masterService.MasterData_GetMutli(propId, row.GlitchStaffId, enumModels.EntityCodes.Staff, "");
        row.GlitchTemperamentName = this.masterService.StaticData_GetMutli(row.GuestTemperamentId, enumModels.EntityCodes.GuestTemperamentMaster, "");
        row.LoggedByName = this.masterService.MasterData_GetMutli(propId, row.LoggedBy, enumModels.EntityCodes.Staff, "");
        row.UpdatedByName = this.masterService.MasterData_GetMutli(propId, row.UpdatedById, enumModels.EntityCodes.Staff, "");
        row.LocationName = this.masterService.MasterData_GetMutli(propId, row.IncidentLocationId, enumModels.EntityCodes.Location, "");
        row.Description = this.masterService.MasterData_GetMutli(propId, row.DescriptionId, enumModels.EntityCodes.GlitchDescriptionMaster, "");
        row.ReservationLocationName = this.masterService.MasterData_GetMutli(propId, row.LocationId, enumModels.EntityCodes.Location, "");

        
        if (row.GlitchStaff != null) {
            for (let i = 0; i < row.GlitchStaff.length; i++) {
                let di = new GenericMaster();
                di.Id = row.GlitchStaff[i];
                di.Name = this.masterService.MasterData_GetMutli(propId, di.Id, enumModels.EntityCodes.Staff, "");
                row.GlitchStaff[i] = di;
            }
        }

        if (row.TaggedStaff && row.TaggedStaff != null) {
            for (let i = 0; i < row.TaggedStaff.length; i++) {
                let di = new GenericMaster();
                di.Id = row.TaggedStaff[i];
                di.Name = this.masterService.MasterData_GetMutli(propId, di.Id, enumModels.EntityCodes.Staff, "");
                row.TaggedStaff[i] = di;
            }
        }

        row.Investigations = [];
        row.Recoveries = [];

        if (row.Actions != null) {
            for (let i = 0; i < row.Actions.length; i++) {
                let di = row.Actions[i];
                //di.GlitchActionTypeName = this.masterService.MasterData_GetMutli(propId, di.GlitchActionType, enumModels.EntityCodes.GlitchActionReason, "");
                //di.GlitchActionTypeName = enumModels.GlitchActionTypes[di.GlitchActionType];
                di.ReasonOrRecoveryName = this.masterService.MasterData_GetMutli(propId, di.ReasonOrRecoveryId, enumModels.EntityCodes.GlitchRecoveryOptionMaster, "");
                di.AddedByName = this.masterService.MasterData_GetMutli(propId, di.AddedBy, enumModels.EntityCodes.Staff, "");
                if (row.IsOpen == false && di.GlitchActionType == 'CLO') {
                    row.ClosedRemarks = di.Remarks;
                }
            }

            row.Investigations = row.Actions.filter(a => a.GlitchActionType == 'INV');
            row.Recoveries = row.Actions.filter(a => a.GlitchActionType == 'REC');
            row.CloseReopenActions = row.Actions.filter(a => (a.GlitchActionType != 'REC' && a.GlitchActionType != 'INV'));
        }

        if (row.AuditLog != null) {
            for (let i = 0; i < row.AuditLog.length; i++) {
                let di = row.AuditLog[i];
                di.LoggedByName = this.masterService.MasterData_GetMutli(propId, di.LoggedBy, enumModels.EntityCodes.Staff, "");
            }
        }

    }
    

    Glitch_Search(req: Glitch_SearchRequest): Promise<ListResponse> {
        return this.apiService.postAPI(this.BaseURL, "Glitch/Glitch_Search", req, false).then(data => {
            if (data != null && data.Result != null) {
                if (req.GroupBy == GlitchSearch_GroupBy.None)
                    this.Glitch_SetText_List(data.Result);
                else
                    this.Glitch_Search_Groups_Multi(data, req);
            }

            return data;
        }).catch(e => console.info(e));
    }

    Glitch_Search_Counts(req: Glitch_SearchRequest): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "Glitch/Glitch_Search_Counts", req, false).then(data => {
            //this.Complain_Search_Multi(data);
            return data;
        });
    }

    FromEdit(row: any): Glitch_UpdateRequest {
        let Req = new Glitch_UpdateRequest();

        Req.Operation = GlitchOperationActions.Edit;

        Req.OriginalLoggedDate = row.LogTime;

        Req.PropertyId = row.PropertyId;
        Req.GlitchId = row.GlitchId;
        Req.GlitchRegistrationType = row.GlitchRegistrationType;
        Req.GlitchStaffId = row.GlitchStaffId;
        Req.Details = row.Details;
        Req.DepartmentId = row.DepartmentId;
        Req.GuestTemperamentId = row.GuestTemperamentId;
        Req.GlitchIncedentDt = row.GlitchIncedentDt;
        Req.IncidentLocationId = row.IncidentLocationId;
        Req.DescriptionId = row.DescriptionId;
        Req.TritonReservationId = row.TritonReservationId;

        Req.GlitchStaff = [];
        if (row.GlitchStaff != null) {
            row.GlitchStaff.forEach(a => Req.GlitchStaff.push(a.Id));
        }

        Req.TaggedStaff = [];
        if (row.TaggedStaff != null) {
            row.TaggedStaff.forEach(a => Req.TaggedStaff.push(a.Id));
        }

       // Req.Attachments = row.Attachments;
        Req.NoOfStays = row.NoOfStays;
        Req.CheckInDate = row.CheckInDate;
        Req.CheckOutDate = row.CheckOutDate;
        Req.LocationId = row.LocationId;
        Req.RoomRate = row.RoomRate;
        Req.CategoryId = row.CategoryId;

        Req.GlitchGuestId = row.GlitchGuestId;
        if (row.GuestInfo != null) {
            Req.Title = row.GuestInfo.Title;
            Req.FName = row.GuestInfo.FName;
            Req.LName = row.GuestInfo.LName;
            Req.FullName = row.GuestInfo.FullName;
            Req.MobileNumber = row.GuestInfo.MobileNumber;
            Req.HomeNumber = row.GuestInfo.HomeNumber;
            Req.Address = row.GuestInfo.Address;
            Req.Email = row.GuestInfo.Email;
        }

        return Req;
    }

    FromCopy(row: any): Glitch_UpdateRequest {
        let Req = new Glitch_UpdateRequest();

        Req.Operation = GlitchOperationActions.Register;

        Req.PropertyId = row.PropertyId;
        Req.GlitchId = null;
        Req.GlitchRegistrationType = enumModels.Glitch_RegistrationTypes.In_House_Guest;
        Req.GlitchStaffId = null;
        Req.Details = row.Details;
        Req.DepartmentId = row.DepartmentId;
        Req.GuestTemperamentId = row.GuestTemperamentId;
        Req.GlitchIncedentDt = new Date();
        Req.IncidentLocationId = row.IncidentLocationId;
        Req.DescriptionId = row.DescriptionId;
        Req.CategoryId = row.CategoryId;
        Req.TritonReservationId = null;

        Req.GlitchStaff = [];
        if (row.GlitchStaff != null) {
            row.GlitchStaff.forEach(a => Req.GlitchStaff.push(a.Id));
        }

        Req.TaggedStaff = [];
        if (row.TaggedStaff != null) {
            row.TaggedStaff.forEach(a => Req.TaggedStaff.push(a.Id));
        }

        Req.Attachments = [];
        Req.NoOfStays = null;
        Req.CheckInDate = null;
        Req.CheckOutDate = null;
        Req.LocationId = null;
        Req.RoomRate = null;
        
        Req.GlitchGuestId = null;
        Req.Title = null;
        Req.FName = null;
        Req.LName = null;
        Req.FullName = null;
        Req.MobileNumber = null;
        Req.HomeNumber = null;
        Req.Address = null;
        Req.Email = null;

        return Req;
    }

    OpenForEdit(row: any): void {
        let req = this.FromEdit(row);

        //console.info(req);

        this.InitiateEdit.emit(req);
    }

    OpenForCopy(row: any): void {
        let req = this.FromCopy(row);

        //console.info(req);

        this.InitiateCopy.emit(req);
    }

    TriggerRequireFullRefresh(): void {
        this.SelectedGlitch = null;
        this.RequireFullRefresh.emit(true);
    }

    Glitch_Action(req: Glitch_ActionRequest): Promise<SimpleResponse> {
        if (req == null)
            return null;

        return this.apiService.postAPI(this.BaseURL, "Glitch/Glitch_Action", req, true).then(data => {
            if (data != null && data.HasError == false && data.Result != null)
                this.Glitch_SetText(data.Result);

            return data;
        });
    }

    Glitch_GetGSRQuestions(PropertyId: number, LanguageCode: string): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "Glitch/Glitch_GetGSRQuestions?PropertyId=" + PropertyId + "&LanguageCode=" + LanguageCode, false).then(data => {
            return data;
        })
    }

    Glitch_SaveGSRRating(complainGSRAnswers: ComplainGSRAnswers): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "Glitch/Glitch_SaveGSRRating", complainGSRAnswers, true).then(data => {
            return data;
        });
    }

    Glitch_GetGSRAudit(GlitchId: number): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "Glitch/Glitch_GetGSRAudit?GlitchId=" + GlitchId, false).then(data => {
            return data;
        });
    }
}
